// extracted by mini-css-extract-plugin
export var disconnectWalletButton = "DisconnectWalletButton-module--disconnectWalletButton--40c64";